import { capitalize } from 'lodash/string';

export const casingPostProcessor = {
  type: 'postProcessor',
  name: 'casing',
  process(value, key, opts) {
    const c = opts?.case;

    if (!c || !['U', 'L', 'C'].includes(c) || typeof value !== 'string') {
      return value;
    }

    if (c === 'U') return value.toUpperCase();
    if (c === 'L') return value.toLowerCase();
    if (c === 'C') return capitalize(value);

    return value;
  }
};
